module.exports = __webpack_public_path__ + "img/Group 8908.cac5bbf4.svg";